// extracted by extract-css-chunks-webpack-plugin
module.exports = {"block":"block_3RpME","block__title":"block__title_3Dj7z","block_inverted":"block_inverted_1vs2N","block__item":"block__item_2NE4-"};